// import axios from "axios";
// import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'

export default {
    namespaced: true,
    state: {
        labNewsElement : {},
        modeLabNewsElement : 0, // 0 == view ,1 == edit
    },

    getters: {
    },

    mutations: {
        setLabNewsElement (state, labNewsElement ) {
            state.labNewsElement  = labNewsElement
        },
        setModeLabNewsElement (state, modeLabNewsElement ) {
            state.modeLabNewsElement  = modeLabNewsElement
        },



    },

    actions: {
        /* eslint-disable no-console */
        // fetchCountIMR({commit},idopd) {

        //     const datPost = {
        //         "idopd" : idopd
        //     }
        //     return new Promise((resolve,reject) => {
        //         axios.post(`${getBaseURLforBackEnd()}/api/imr_countbyopdno`,datPost,getConfigAxios())
        //             .then((res)=>{
        //                 commit('setCountIMR', res.data.count)
        //                 resolve(res.data.count)
        //             })
        //             .catch((err) =>{
        //                 reject(err)
        //             })
        //     })
        // },



    }
}